export default "__VITE_ASSET__77029dc0__"